var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeStyleHobby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lifeStyleHobby-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-19.896 1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lifeStyleHobby",
    transform: "translate(19.896 -1)",
    clipPath: "url(#lifeStyleHobby-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.813,14.5l-13.2,15.4H18.2L25.9,14.5Z",
    transform: "translate(-6.179 -4.8)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.156,2c1.1,1.1,1.118,1.1,6.6,1.1a118.02,118.02,0,0,0,5.5,21.993",
    transform: "translate(-19.22)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.555,6.236,36.821,26.726",
    transform: "translate(-9.389 -1.627)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.893,4.429c0,.784-1.226,1.5-4.042,1.5-2.924,0-5.859,2.953-5.859-.569,0-1.02.226-1.568,1.484-1.568h7.1C29.356,3.8,29.893,3.817,29.893,4.429Z",
    transform: "translate(-6.869 -0.689)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015,43.227a9.9,9.9,0,1,0-9.912-9.9A9.906,9.906,0,0,0,12.015,43.227Z",
    transform: "translate(0 -8.227)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.629,43.227a9.9,9.9,0,1,0-9.912-9.9A9.906,9.906,0,0,0,65.629,43.227Z",
    transform: "translate(-20.588 -8.227)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStyleHobby);
export default __webpack_public_path__ + "static/media/lifeStyleHobby.3799b74032550f867e2e477e46a1a476.svg";
export { ForwardRef as ReactComponent };